import { Route, Routes } from 'react-router'
import { observer } from 'mobx-react-lite'
import PublicLayout from './routes/PublicLayout'
import { authRoutes, privateRoutes } from './routes'
import PrivateLayout from './routes/PrivateLayout'
import { usePageContext } from './context/PageContext'
import { useEffect } from 'react'
import Loader from './components/Loader/Loader'
import Modal from './components/Modal/Modal'
import NotFound from './pages/NotFound'

const App = observer(() => {
    const { pageStore } = usePageContext();
    useEffect(() => {
        const hash = window.__TG_HASH__ || window.location.hash;
        const params = new URLSearchParams(hash.slice(1));
        const tgWebAppData = params.get("tgWebAppData");

        if (tgWebAppData) {
            const decodedOnce = decodeURIComponent(tgWebAppData);
            const userPart = decodedOnce.split("user=")[1]?.split("&")[0];
            const decodedTwice = decodeURIComponent(userPart);
            const {username, id: tgId} = JSON.parse(decodedTwice);
            pageStore.authWithTg(username, tgId);
        } else if (localStorage.getItem('token')) {
            pageStore.checkIsAuth();
        }
    }, [])

    return (
        <>
            {pageStore.isError &&
                <Modal className={'error_modal modal_center'} handleClose={() => pageStore.setIsError(false)}>
                    <h1 className="modal_title">
                        {pageStore.isError}
                    </h1>
                </Modal>
            }
            {pageStore.isLoading && <Loader />}
            <div className="page_wrapper">
                <Routes>
                    <Route element={<PublicLayout />}>
                        {authRoutes.map((route) => (
                            <Route
                                key={route.path}
                                path={route.path}
                                element={<route.component />}
                            />
                        ))}
                    </Route>
                    <Route element={<PrivateLayout />}>
                        {privateRoutes.map((route) => (
                            <Route
                                key={route.path}
                                path={route.path}
                                element={<route.component />}
                            />
                        ))}
                    </Route>
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </div>
        </>
    )
})

export default App
